<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15lPcl5/images/9781466886896.jpg?1718046172245" alt="This image is the cover for the book Anti-Aging for Dogs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anti-Aging for Dogs
      </h1>
      <p class="bookDescription body article font2">
        <p>You love your dog. Don't you want to keep him around for a good long time?<br/><br/>You take steps to slow down your own aging process and stay as healthy and fit as possible-- now you can do the same for you beloved dog. Learn Dr. John Simon's amazing program for canine longevity in <i>Anti-Aging for Dogs</i>, and your best friend can live years beyond his normal life expectancy. Simple but effective changes in your dog's lifestyle, diet, exercise program, environment, and behavior can yield astounding results. In this invaluable manual-- the first of its kind-- well-known and respected veterinarian Dr. John M. Simon tells you how to put this powerful program to use, with essential advice about:<br/><br/>* Ensuring that your dog gets the right exercise, grooming, and dental hygiene<br/>* Creating a safe, healthy home environment for your dog<br/>* Avoiding common canine behavioral problems<br/>* Programs for assuring optimal nutrition, digestion, and detoxification<br/>* Plus: helpful appendices on first aid, toxic substances, and health maintenance</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John M. Simon, Steve Duno
      </h2>
      
      <p class="authorDescription body article"><P><B>John M. Simon, D.V.M.</B>, has over twenty-five years of experience in conventional and alternative pet care. He owns a private practice, Woodside Animal Hospital, in Royal Oak, Michigan, and has a regular column in Detroit's <I>Daily Tribune. </I> His books include <I>Anti-Aging for Dogs</I>, <I>What Your Cat is Trying to Tell You</I>, and <I>What Your Dog is Trying to Tell You</I>.<br><br><B>Steve Duno</B> is a freelance writer in Seattle, Washington. He is the author of <I>Last Dog on the Hill</I> and has coauthored several books. He has also published fiction and appeared on television and radio.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s. Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4780bfd1